import React from 'react';
import styles from './styles';
import {Button, Icons} from '../../';


const IconButton = props => {

  let buttonProps = {...props};
  delete buttonProps.size;
  delete buttonProps.icon;
  delete buttonProps.iconStyles;
  delete buttonProps.styles;

  const size = props.size || 'sm';

  return(
    <Button
      {...buttonProps}
      styles={{...styles['button_' + size], ...props.styles}}
    >
      <Icons icon={props.icon} style={{...styles['icon_' + size], ...props.iconStyles}} />
    </Button>
  )
}

export default IconButton;
